import React, { useState } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { useWizard } from 'react-use-wizard'
import { DocumentAddStep } from '../model'
import Camera, { FACING_MODES } from 'react-html5-camera-photo'
import 'react-html5-camera-photo/build/css/index.css'
import '../styles.scss'
import SpinnerEllipsis from 'components/atoms/SpinnerEllipsis'

interface StepTakePhotoProps {
  onPhotoTaken: (image: string) => void
}

const cameraEnableInstruction =
  "If your camera does not load, make sure to enable your camera in your browser's settings."

const StepTakePhoto = (props: StepTakePhotoProps): JSX.Element => {
  const { nextStep, previousStep } = useWizard()
  const [loading, setLoading] = useState(true)
  const [showCamera, setShowCamera] = useState(true)

  const handleTakePhoto = (dataUri: string) => {
    setShowCamera(false)
    nextStep(DocumentAddStep.PreviewPhoto).then(() =>
      props.onPhotoTaken(dataUri)
    )
  }

  const renderWaitMessage = () => {
    return (
      <div>
        <SpinnerEllipsis showText={true} text='Loading camera' />
        <div className='mt-2' style={{ fontSize: '12px' }}>
          {cameraEnableInstruction}
        </div>
      </div>
    )
  }

  function handleCameraError(error: Error) {
    console.log('Error while loading camera ', error)
  }

  return (
    <React.Fragment>
      <Container>
        <Row>
          <Col>
            <h2>Take a Photo</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            {loading && renderWaitMessage()}
            {showCamera && (
              <div hidden={loading}>
                <Camera
                  onCameraStart={() => setLoading(false)}
                  isImageMirror={false}
                  idealFacingMode={FACING_MODES.ENVIRONMENT}
                  onTakePhoto={(dataUri) => {
                    handleTakePhoto(dataUri)
                  }}
                  onCameraError={(error) => {
                    handleCameraError(error)
                  }}
                />
              </div>
            )}
          </Col>
        </Row>
      </Container>

      <div className='modal-footer modal-footer-custom mt-3'>
        <Button
          className='footer-btn btn-custom-secondary'
          variant='outline-secondary'
          onClick={() => previousStep(DocumentAddStep.Start)}
        >
          Cancel
        </Button>
      </div>
    </React.Fragment>
  )
}

export default StepTakePhoto
